import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const OperatingSystem = ({ onOperatingSystemSelected }) => {
  const [selectedOperatingSystem, setSelectedOperatingSystem] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.operatingsystem) {
        const operatingSystemObject = firstResult.operatingsystem;
        if (operatingSystemObject.trim() !== "") {
          setVariations(operatingSystemObject.split(","));
        }
      }
    } catch (error) {
      console.error("Error fetching product variations:", error);
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleOperatingSystemClick = (operatingsystem) => {
    setSelectedOperatingSystem(operatingsystem);
    onOperatingSystemSelected(operatingsystem);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Operating System:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedOperatingSystem === variation ? "selected" : ""}`}
            onClick={() => handleOperatingSystemClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default OperatingSystem;
